import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="mb-5">
          <Col lg={4} className="mb-4 mb-lg-0">
            <div className="mb-4">
              <Link to="/">
                <img
                  src="/images/golf-logo.png"
                  alt="Golf4International Logo"
                  style={{
                    height: '50px',
                    width: 'auto',
                    maxWidth: '200px',
                    filter: 'brightness(0) invert(1)'
                  }}
                />
              </Link>
            </div>
            <p className="mb-3" style={{ opacity: 0.8 }}>
              Making golf accessible and within reach of all enthusiasts, demystifying and compressing the game into a shorter, affordable version.
            </p>
          </Col>

          <Col lg={2} md={4} className="mb-4 mb-md-0">
            <h5 className="mb-4">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><Link to="/">Home</Link></li>
              <li className="mb-2"><Link to="/services">Services</Link></li>
              <li className="mb-2"><Link to="/academy">Academy</Link></li>
              <li className="mb-2"><Link to="/about">About Us</Link></li>
              <li><Link to="/blog">Blog</Link></li>
            </ul>
          </Col>

          <Col lg={3} md={4} className="mb-4 mb-md-0">
            <h5 className="mb-4">Services</h5>
            <ul className="list-unstyled">
              <li className="mb-2">Golf Simulators</li>
              <li className="mb-2">Golf Academy</li>
              <li className="mb-2">Pro Shop</li>
              <li>Custom Equipment</li>
            </ul>
          </Col>

          <Col lg={3} md={4}>
            <h5 className="mb-4">Contact Us</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <i className="fas fa-map-marker-alt me-2"></i>
                416/2, Rajbir Gautam House, Ghitorni, M.G. Road, South West Delhi, PIN : 110030
              </li>
              <li className="mb-2">
                <i className="fas fa-phone me-2"></i>
                +91 8130804488
              </li>
              <li className="mb-2">
                <i className="fas fa-envelope me-2"></i>
                cmd@heimdall.org.in
              </li>
              <li>
                <i className="fas fa-globe me-2"></i>
                www.golf4i.com
              </li>
            </ul>
          </Col>
        </Row>

        <hr style={{ borderColor: 'rgba(255,255,255,0.1)' }} />

        <Row className="pt-3">
          <Col md={6}>
            <p className="mb-0" style={{ opacity: 0.8 }}>
              © {new Date().getFullYear()} Golf4International Private Limited. All rights reserved.
            </p>
          </Col>
          <Col md={6} className="text-md-end">
            <p style={{ opacity: 0.8 }}>
              Designed with precision for the modern golfer
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;